module.exports = __webpack_public_path__ + "media/images/concept_design_award_participate_icon-w-33032abc457a82369f593d2f36ff0203.png";